var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 30,
    viewBox: "0 0 40 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.875 0.625H3.125C1.40195 0.625 0 2.02695 0 3.75V26.25C0 27.973 1.40195 29.375 3.125 29.375H36.875C38.598 29.375 40 27.973 40 26.25V3.75C40 2.02695 38.598 0.625 36.875 0.625Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 13.125H6.25C5.55961 13.125 5 12.5654 5 11.875V6.875C5 6.18461 5.55961 5.625 6.25 5.625H13.75C14.4404 5.625 15 6.18461 15 6.875V11.875C15 12.5654 14.4404 13.125 13.75 13.125Z",
    fill: "#FFD100"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 21.25H6.25C5.55961 21.25 5 20.6904 5 20V19.375C5 18.6846 5.55961 18.125 6.25 18.125H9.375C10.0654 18.125 10.625 18.6846 10.625 19.375V20C10.625 20.6904 10.0654 21.25 9.375 21.25Z",
    fill: "#B8BAC0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 21.25H14.375C13.6846 21.25 13.125 20.6904 13.125 20V19.375C13.125 18.6846 13.6846 18.125 14.375 18.125H17.5C18.1904 18.125 18.75 18.6846 18.75 19.375V20C18.75 20.6904 18.1904 21.25 17.5 21.25Z",
    fill: "#B8BAC0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.625 21.25H22.5C21.8096 21.25 21.25 20.6904 21.25 20V19.375C21.25 18.6846 21.8096 18.125 22.5 18.125H25.625C26.3154 18.125 26.875 18.6846 26.875 19.375V20C26.875 20.6904 26.3154 21.25 25.625 21.25Z",
    fill: "#B8BAC0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.75 21.25H30.625C29.9346 21.25 29.375 20.6904 29.375 20V19.375C29.375 18.6846 29.9346 18.125 30.625 18.125H33.75C34.4404 18.125 35 18.6846 35 19.375V20C35 20.6904 34.4404 21.25 33.75 21.25Z",
    fill: "#B8BAC0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 25H5.625C5.27953 25 5 24.7202 5 24.375C5 24.0298 5.27953 23.75 5.625 23.75H18.125C18.4705 23.75 18.75 24.0298 18.75 24.375C18.75 24.7202 18.4705 25 18.125 25Z",
    fill: "#8A8895"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 25H20.625C20.2795 25 20 24.7202 20 24.375C20 24.0298 20.2795 23.75 20.625 23.75H26.25C26.5955 23.75 26.875 24.0298 26.875 24.375C26.875 24.7202 26.5955 25 26.25 25Z",
    fill: "#8A8895"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10H8.75V8.75H15V7.5H8.75V5.625H7.5V13.125H8.75V11.25H15V10Z",
    fill: "#FF9500"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 13.125C33.3211 13.125 35 11.4461 35 9.375C35 7.30393 33.3211 5.625 31.25 5.625C29.1789 5.625 27.5 7.30393 27.5 9.375C27.5 11.4461 29.1789 13.125 31.25 13.125Z",
    fill: "#FE5A3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardImage);
export default __webpack_public_path__ + "static/media/cardImage.9d5a9e7b8ecd7c964939a97f5bb66dab.svg";
export { ForwardRef as ReactComponent };